import * as React from 'react';

import { connect } from 'react-redux';
import withCurrentPageName, {
  PageNameProps,
} from 'ha/helpers/withCurrentPageName';
import { track as trackAction } from 'ha/modules/Analytics/actions';

import Track from './Track';

interface OwnProps {
  name: string;
  type: string;
  socialvendor?: string;
  enabled?: boolean;
  getDynamicData?: (event: string) => object;
}

interface Props {
  track: (eventName: string, params: {}) => void;
}

class SmartTrack extends React.PureComponent<Props & PageNameProps & OwnProps> {
  render() {
    const { pageName, track, ...rest } = this.props;
    return <Track page={pageName} onTrack={track} {...rest} />;
  }
}

export default connect(
  null,
  {
    track: trackAction,
  },
)(withCurrentPageName(SmartTrack));
